export default "__VITE_ASSET__0b8514a6__"